import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App'

const data = window.__SSR_DATA__ || [{}];


hydrateRoot(
  document.getElementById('root'),
   <HelmetProvider>
     <BrowserRouter basename='/photos/'>
       <App data={data}  />
     </BrowserRouter>
 </HelmetProvider>
);